import { TextInput } from '@/schemas/sceneDataSchema';
import { UseFormReturn } from 'react-hook-form';
import { GenericInput } from './GenericInput';

export const InputTextFormElement = ({ form, component }: { form: UseFormReturn; component: TextInput }) => {
  return (
    <GenericInput
      form={form}
      component={component}
      type='text'
    />
  );
};
